import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_9rhufegspe_thi_82406891df: FaireThemeEntity = {
  token: "board_demo_r_9rhufegspe_thi_82406891df",
  type: "theme",
  retailerToken: "r_9rhufegspe",
  name: "Asbury Park Spring Disco Bazaar Picks",
  description:
    "Eye-catching jewelry and statement accessories that reflect the vibrant, disco-inspired energy of the Asbury Park Bazaar spring event.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/b0f2ab9b270b9f618261253ed6ac77f3d82f3fe9ccba94fe77bc7b34b083e8bc.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/b0f2ab9b270b9f618261253ed6ac77f3d82f3fe9ccba94fe77bc7b34b083e8bc.jpeg",
    "https://cdn.faire.com/fastly/f141ad049c8a1a83bbb58f462e0c94c22396d5bf4a03d8db5b124c063094239c.jpeg",
    "https://cdn.faire.com/fastly/223579daaff2de01d53e7d640ffb6fe6e9b74affbdc40e5f166923b4e61d40b0.jpeg",
    "https://cdn.faire.com/fastly/debbe422a5ad633a090b875d3c8d74f0889cc4d6a85eddb6bca41a0a360b1431.jpeg",
    "https://cdn.faire.com/fastly/2056bb844aea17dc429ae2dd4e93e1ab9495c1a686339251052d0e8cb99ab88a.jpeg",
    "https://cdn.faire.com/fastly/579c52b9201982b71b1702bf230ca369470a6de57aaee5f69e1bb3e36e4572d9.png",
  ],
  itemCount: 65,
  source: "eric_themes_ideas",
  teaser: "thi_82406891df",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
